import React, { useEffect } from 'react';

import { useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

import { TFLoadingOverlay } from '@tf/ui';

export const SignOutRoute: React.FC = () => {
	const navigate = useNavigate();
	const { signOut } = useClerk();

	useEffect(() => {
		signOut().finally(() => {
			navigate('/sign-in');
		});
	}, [navigate, signOut]);

	return <TFLoadingOverlay />;
};
